<template>
  <footer>
    <div class="wrapper">
      <div class="content">
        <div class="row">
          <div class="media-icons">
            <a href="https://www.instagram.com/icims_inc/" target="_blank">
              <img alt="instagram" src="../assets/vectors/ig-icon.svg" class="logo" />
            </a>
            <a href="https://www.facebook.com/iCIMS/" target="_blank">
              <img alt="facebook" src="../assets/vectors/fb-icon.svg" class="logo" />
            </a>
            <a href="https://twitter.com/iCIMS" target="_blank">
              <img alt="twitter" src="../assets/vectors/twitter-icon.svg" class="logo" />
            </a>
            <a href="https://www.linkedin.com/company/icims/" target="_blank">
              <img alt="twitter" src="../assets/vectors/linkedin.svg" class="logo" />
            </a>
          </div>
          <div class="locale-changer">
            <font-awesome-icon :icon="['fas', 'language']" />
            <select :title="t('LANGUAGE SELECTOR')" v-model="locale">
              <option v-for="locale in availableLocales" :key="`locale-${locale}`" :value="locale">
                {{ getDisplayName(locale) }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="copyright">
            &copy;
            {{ new Date().getFullYear() }}
            <a href="https://www.icims.com/" target="_blank"
              ><img alt="iCIMS logo site" src="../assets/images/icims-logo.png" class="logo site"
            /></a>
          </div>
          <div class="links">
            <a href="https://www.icims.com/legal/privacy-notice-services/" target="_blank">{{ t('PRIVACY POLICY') }}</a>
            <a href="https://www.altrulabs.com/terms" target="_blank">{{ t('TERMS & CONDITIONS') }}</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { Locale, useI18n } from 'vue-i18n';
import { Ref } from 'vue';

export default {
  name: 'Footer',
  setup(): {
    t: (key: string) => string;
    locale: Ref<Locale>;
    availableLocales: Locale[];
    getDisplayName: (locale: string) => string;
  } {
    const { t, locale, availableLocales } = useI18n();

    const getDisplayName = (locale: string) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const nameGenerator = new Intl.DisplayNames(locale, { type: 'language' });
      return nameGenerator.of(locale) ?? locale;
    };

    return { t, locale, availableLocales, getDisplayName };
  },
};
</script>

<style lang="scss" scoped>
footer {
  background-color: $footer-background;
  color: $footer-color;
  margin-top: auto;
  padding: 1.25rem 0;

  .content {
    --gap: 14px;
    display: flex;
    flex-direction: column;
    gap: var(--gap);

    .logo {
      height: 1rem;
      width: auto;

      &.site {
        height: 0.75rem;
        @media (min-width: $mobile) {
          height: 1rem;
        }
      }
    }

    .copyright {
      font-size: 0.85rem;

      img {
        margin-left: 0.25rem;
      }
    }

    .links {
      align-items: center;
      display: flex;
      font-size: 0.85rem;
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
      gap: var(--gap);

      a {
        color: $footer-color;
      }
    }

    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;
      gap: var(--gap);

      @media (min-width: $mobile-small) {
        justify-content: space-between;
      }

      @media (min-width: $tablet) {
        gap: 16px;
      }

      .media-icons {
        display: flex;
        gap: 8px;

        a {
          align-items: center;
          background-color: $black;
          border-radius: 50%;
          display: flex;
          height: 24px;
          justify-content: center;
          width: 24px;
          flex-shrink: 0;

          @media (min-width: $mobile) {
            padding: 0.25rem;
            transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
              box-shadow 0.15s ease-in-out;
            &:not(:first-child) {
              margin-left: 0;
            }
          }
        }
      }

      .locale-changer {
        display: flex;
        align-items: center;
        position: relative;
        gap: 8px;

        @media (min-width: $mobile-small) {
          margin-left: auto;
        }

        &:after {
          content: '';
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid #303030;
          position: absolute;
          top: 50%;
          right: 16px;
          transform: scale(0.5) translateY(-50%);
        }

        svg {
          height: 24px;
          width: 24px;
        }

        select {
          border-top: 5px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 5px solid transparent;
          border-left: 5px solid transparent;
          -webkit-appearance: none;
          padding-right: 0.75rem;
        }
      }
    }
  }
}
</style>
